function positionScrolls() {
  const scrollElements = document.querySelectorAll('.scroll[data-layout]');
  if (!scrollElements.length) return;

  function updateOne(element) {
    const value = element.scrollWidth > element.clientWidth ? 'flex-start' : 'center';
    // Only write when the value actually changes. Setting justify-content
    // re-lays-out the children, which can re-fire the ResizeObserver; the
    // equality guard stops that from oscillating flex-start <-> center.
    if (element.style.justifyContent !== value) {
      element.style.justifyContent = value;
    }
  }

  scrollElements.forEach(element => {
    let frame = null;
    const resizeObserver = new ResizeObserver(() => {
      // Coalesce bursts into a single rAF so the callback can't run
      // re-entrantly against its own layout writes.
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        updateOne(element);
      });
    });
    resizeObserver.observe(element);
  });

  let winFrame = null;
  window.addEventListener('resize', () => {
    if (winFrame) return;
    winFrame = requestAnimationFrame(() => {
      winFrame = null;
      scrollElements.forEach(updateOne);
    });
  });

  scrollElements.forEach(updateOne);
}

function alignScrollItemHeights() {
  const elements = document.querySelectorAll('.scroll[data-layout]');
  elements.forEach(element => {
    if (element.closest('.social-reviews--mosaic')) return;

    const items = Array.from(element.querySelectorAll('.scroll-item'));
    if (!items.length) return;

    items.forEach(i => i.style.minHeight = 'auto');
    const maxHeight = Math.max(...items.map(i => i.offsetHeight));
    items.forEach(i => i.style.minHeight = `${maxHeight}px`);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  positionScrolls();
});

document.addEventListener('DOMContentLoaded', () => {
  alignScrollItemHeights();
});

// Debounce the height alignment to one run per frame; it reads offsetHeight
// in a loop (forced reflow), so an unthrottled resize handler thrashes layout.
let alignFrame = null;
window.addEventListener('resize', () => {
  if (alignFrame) return;
  alignFrame = requestAnimationFrame(() => {
    alignFrame = null;
    alignScrollItemHeights();
  });
});
